module.exports = __webpack_public_path__ + "static/media/apple-app-store.b13a95cb.png";